import { safe } from './object'

export function extractScreen({ screen = {} as unknown as Screen }: Window) {
  return {
    height: screen.height,
    width: screen.width,
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    orientation: screen.orientation?.type, // safari workaround
    colorDepth: screen.colorDepth,
  }
}

export function extractTiming({ performance = {} as unknown as Performance }: Window) {
  return { navigation: performance.getEntriesByType('navigation') }
}

export function extractNetwork(window: Window) {
  return {
    downlink: safe(window, 'navigator', 'connection', 'downlink'),
    effectiveType: safe(window, 'navigator', 'connection', 'effectiveType'),
    type: safe(window, 'navigator', 'connection', 'type'),
    saveData: safe(window, 'navigator', 'connection', 'saveData'),
    rtt: safe(window, 'navigator', 'connection', 'rtt'),
  }
}
